import {
  UploadedReceiptStatus,
  LexOfficeBookingData,
  DatevBookingData,
} from '../../../types';

export const BOOKING_REVIEW_STATUSES: UploadedReceiptStatus[] = [
  'generated',
  'modified',
  'import-scheduled',
  'importing',
  'imported',
  'import-failed',
];

// Bulk Operation types
export interface BulkOperation {
  id: string;
  userId: string;
  title: string;
  description?: string;
  bookingSystem: 'lexoffice' | 'datev';
  receiptIds: string[];
  createdAt: string;
  updatedAt: string;
}

// Request types for API calls
export interface CreateReceiptRequest {
  storageKey: string;
  contentType: string;
  originalFileName: string;
  fileSizeInBytes: number;
}

export interface CreateBulkOperationRequest {
  title: string;
  description?: string;
  bookingSystem?: 'lexoffice' | 'datev';
  receiptIds: string[];
}

export interface UpdateBulkOperationRequest {
  title?: string;
  description?: string;
}

export interface AddReceiptsToBulkOperationRequest {
  receiptIds: string[];
}

export interface ProposeChangeRequest {
  lexOfficeBooking?: LexOfficeBookingData;
  datevBooking?: DatevBookingData[];
}
